"use client";

import React from "react";
import { Box, Typography, Button } from "@mui/material";

interface ErrorStateProps {
  error: string | null;
  onBackClick: () => void;
}

export const ErrorState: React.FC<ErrorStateProps> = ({
  error,
  onBackClick,
}) => {
  return (
    <Box textAlign="center" my={4}>
      <Typography color="error" variant="h6">
        {error || "No venue data available."}
      </Typography>
      <Button variant="contained" onClick={onBackClick} sx={{ mt: 2 }}>
        Back to Venues
      </Button>
    </Box>
  );
};

export default ErrorState;
